import type { PredictResponse } from './domain'
import type { EditablePlan } from './useEditablePlan'

export type ExportSheetRow = { color: string | null; interior: string | null; trim: string | null; rim: string | null; quantity: number }
export type ExportSheetBlock = { nmc_model_code: string | null; packages: string[]; single_options: string[]; n_cars: number; rows: ExportSheetRow[]; nmc_extra_packages: string[]; nmc_included: string[] }
export type ExportSheet = { label: string; model_group: string; model_codes: string[]; n_cars: number; blocks: ExportSheetBlock[] }

export function serializePlanForExport(result: PredictResponse, label: string, plan: EditablePlan): ExportSheet {
  const { blocks, lines, planN, allocation } = plan
  const quantities = allocation?.quantities ?? {}
  const outBlocks: ExportSheetBlock[] = []
  for (const b of blocks) {
    const members = lines.filter(l => l.blockRank === b.rank)
    const blockTotal = members.reduce((s, l) => s + (quantities[l.id] ?? 0), 0)
    const isUser = b.source === 'user'
    // Mirror BlockCard: hide model blocks squeezed to 0 cars; keep user-added ones.
    if (!isUser && (members.length === 0 || blockTotal === 0)) continue
    const visible = members.filter(l => l.source === 'user' || (quantities[l.id] ?? 0) >= 1)
    outBlocks.push({
      nmc_model_code: b.nmc_model_code,
      packages: b.packages,
      single_options: b.single_options,
      n_cars: blockTotal,
      rows: visible.map(l => ({
        color: l.color, interior: l.interior, trim: l.trim, rim: l.rim,
        quantity: quantities[l.id] ?? 0,
      })),
      nmc_extra_packages: b.nmc_extra_packages,
      nmc_included: b.nmc_included ?? [],
    })
  }
  return {
    label,
    model_group: result.model_group,
    model_codes: result.model_codes,
    n_cars: allocation?.total ?? planN,
    blocks: outBlocks,
  }
}
